import { FC, ReactNode } from 'react';

import { Button } from '../../../../index';

import s from './BottomButton.module.scss';

export interface BottomButtonProps {
  children: ReactNode;
}

const BottomButton: FC<React.PropsWithChildren<React.PropsWithChildren<BottomButtonProps>>> = ({ children }) => {
  return (
    <Button.StickyBottom.Wrapper className={s.buttonWrapper} isInDrawer>
      {children}
    </Button.StickyBottom.Wrapper>
  );
};

export default BottomButton;
